/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IPlatformPixelConverter_$type } from "./IPlatformPixelConverter";
/**
 * @hidden
 */
var BrowserPixelConverter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(BrowserPixelConverter, _super);
    function BrowserPixelConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserPixelConverter.prototype.devicePixelsToPixel = function (a) {
        return a;
    };
    BrowserPixelConverter.$t = markType(BrowserPixelConverter, 'BrowserPixelConverter', Base.$, [IPlatformPixelConverter_$type]);
    return BrowserPixelConverter;
}(Base));
export { BrowserPixelConverter };
//# sourceMappingURL=BrowserPixelConverter.js.map
